import type { TaskChip } from "@memorang/ui/components/HomeApplet/types";
import type { SessionReportNextActionDialogSession } from "@memorang/ui/components/SessionReport/SessionReportNextActionDialog";
import { getSkillIcon } from "@memorang/ui/constants";
import type { TFunction } from "i18next";
import type {
	QuickStudyMeta,
	RecommendedSkillTask,
} from "./dashboard-task-types";

export type RecommendedSessionDialogContent = {
	session: SessionReportNextActionDialogSession;
	insight: string;
};

export const buildRecommendedSessionChips = (
	quickStudyMeta: QuickStudyMeta | undefined,
	translate: TFunction,
): TaskChip[] => {
	if (!quickStudyMeta) {
		return [];
	}
	const { numItems, minutes } = quickStudyMeta;
	return [
		{
			icon: "card-multiple-outline",
			label: translate("dashboard.recommendedTasks.itemsChip", {
				count: numItems,
			}),
		},
		{
			icon: "clock-outline",
			label: translate("sessionConfig.quickStudy.duration", { minutes }),
		},
	];
};

export const buildRecommendedSessionDialogContent = (
	task: RecommendedSkillTask,
	translate: TFunction,
): RecommendedSessionDialogContent | null => {
	const { quickStudyMeta, recommendation } = task;
	if (!quickStudyMeta) {
		return null;
	}

	const { skill, questionTypes = [] } = recommendation;
	const { numItems, minutes } = quickStudyMeta;
	const questionTypeTitles = questionTypes.map(({ title }) => title).join(", ");

	return {
		session: {
			icon: getSkillIcon(skill.title),
			title: questionTypeTitles
				? `${skill.title} · ${questionTypeTitles}`
				: skill.title,
			subtitle: task.body ?? "",
			chips: buildRecommendedSessionChips(quickStudyMeta, translate),
		},
		insight: translate("sessionConfig.quickStudy.summary", {
			count: numItems,
			skill: skill.title,
			minutes,
			...(questionTypeTitles
				? { context: "questionType", questionType: questionTypeTitles }
				: {}),
		}),
	};
};
